var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDiagonalBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "translate(0.710938 0.0800781)",
    fill: "url(#pattern0_3169_20809)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3169_20809",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3169_20809",
    transform: "scale(0.0138889)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3169_20809",
    width: 72,
    height: 72,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA8UExURQAAABAwUBAwUAgwUAswUAwwUA0wUA0wUA0wUA4wUwswUAwwUA0wUg0wUA0wUQwwUA4wUQ0wUQ0wUQ0wUZQSoyUAAAATdFJOUwAQICAwQFBfYG9wkJ+gv7/P3+9tUp+pAAAArUlEQVR42u3XOw4CMQwAUcPyyf6AkPvflXIaRIKmXM8BnmTJhR1ZlmXZv83v9qPXHIOV1mmLsdbW6xpDLV1ojaFOVc5Gt/K1CqTaGpBzgKQD5J1agZQzPYCUE0DOAXIOkHOAnAMkHSDpAEkHSDpA0gGSDpB0gKQDJB0g6QBJB0g6QNIBkg6QdICkA+QcTpW7crgwduPQZXIOHdgpOK4dx7V4h6V94pjOU75PWUYfr7Us4z6bn1oAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDiagonalBlue);
export default __webpack_public_path__ + "static/media/arrow_diagonal_blue.2a5a34758f1788a8841e8324db9c06f2.svg";
export { ForwardRef as ReactComponent };